// extracted by mini-css-extract-plugin
export var innerProgressBar = "demo-quiz-module--inner-progress-bar--4d047";
export var progressBar = "demo-quiz-module--progress-bar--4fd41";